import { selectUserData, ACCOUNT_TYPE, fetchUserData } from '../accountSlice'
import PaymentMethodBadges from './PaymentMethodBadges'
import { useDispatch, useSelector } from 'react-redux'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import Skeleton from 'react-loading-skeleton'
import { STATUS } from 'utils/constants'
import Error from 'components/Error'
import { useEffect } from 'react'

const type = ACCOUNT_TYPE.cards

const PaymentCard = () => {
  const { status = STATUS.idle, data } = useSelector(state => selectUserData(state, type))
  const hasData = Array.isArray(data)

  const { t } = useTranslation('account')
  const { openPopup } = usePopupState()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchUserData(type))
  }, [dispatch])

  const openAddPopup = () => {
    openPopup({ type: 'addPaymentMethod' })
  }

  const renderMethod = (method) => (
    <div
      key={method.id}
      className={`list__element --big${method.status !== 'active' ? ' --inactive' : ''}`}
      onClick={() => {
        openPopup({ type: 'paymentMethod', props: { id: method.id } })
      }}>
      <div className='group'>
        <div>
          <div className='element__title pmTitle'>
            <span>{method.displayName}</span>
            <PaymentMethodBadges method={method} />
          </div>
          <div className='element__desc'>{method.operator}{method.cardValidityDate ? ` · ${method.cardValidityDate}` : ''}</div>
        </div>
        <div className='element__arrow'>
          <i className='icon icon--arrow-right' />
        </div>
      </div>
    </div>
  )

  const renderEmpty = () => (
    <div
      className='list__element --big'
      onClick={openAddPopup}>
      <div>
        <div className='element__title'>{t('noSavedMethods')}</div>
        <div className='element__desc'>{t('noSavedMethodsDesc')}</div>
      </div>
    </div>
  )

  return (
    <div>
      <div className='group'>
        <p>{t('automaticPayments')}</p>
        {hasData && <span
          className='addNew__button --secFont'
          onClick={openAddPopup}>
          {t('add')} →
        </span>}
      </div>
      <div className='account__list list account__card'>
        {status === STATUS.failed
          ? <Error staticPos />
          : hasData
            ? data.length > 0 ? data.map(renderMethod) : renderEmpty()
            : <div className='list__element --big --skeleton'>
              <div>
                <Skeleton className='skeleton__title' />
                <Skeleton className='skeleton__desc' />
              </div>
            </div>}
      </div>
    </div>
  )
}

export default PaymentCard
